export default {
  default: () => import("/var/www/sites/auth.ultrafedt.dk/releases/20251107195032/layouts/default.vue")
}